export var BusinessType;
(function (BusinessType) {
    BusinessType["CORPORATION"] = "CORPORATION";
    BusinessType["SOLE_PROPRIETORSHIP"] = "SOLE_PROPRIETORSHIP";
    BusinessType["PARTNERSHIP"] = "PARTNERSHIP";
    BusinessType["FOREIGN_NONSEC"] = "FOREIGN_NONSEC";
})(BusinessType || (BusinessType = {}));
export var InvidualType;
(function (InvidualType) {
    InvidualType["PIC"] = "PIC";
    InvidualType["INCORPORATOR"] = "INCORPORATOR";
})(InvidualType || (InvidualType = {}));
export var GenderType;
(function (GenderType) {
    GenderType["MALE"] = "MALE";
    GenderType["FEMALE"] = "FEMALE";
    GenderType["OTHER"] = "OTHER";
})(GenderType || (GenderType = {}));
export var PrimaryIDs;
(function (PrimaryIDs) {
    PrimaryIDs["AUTHORIZED_PERSON_PASSPORT_DOCUMENT"] = "AUTHORIZED_PERSON_PASSPORT_DOCUMENT";
    PrimaryIDs["DRIVER_LICENCE_DOCUMENT"] = "DRIVER_LICENCE_DOCUMENT";
    PrimaryIDs["PHILSYS_DOCUMENT"] = "PHILSYS_DOCUMENT";
    PrimaryIDs["ACR_OR_IMMIGRANT_COR_DOCUMENT"] = "ACR_OR_IMMIGRANT_COR_DOCUMENT";
    PrimaryIDs["UMID_DOCUMENT"] = "UMID_DOCUMENT";
    PrimaryIDs["SSS_OR_GSIS_DOCUMENT"] = "SSS_OR_GSIS_DOCUMENT";
    PrimaryIDs["PRC_LICENSE_DOCUMENT"] = "PRC_LICENSE_DOCUMENT";
    PrimaryIDs["POSTAL_ID_DOCUMENT"] = "POSTAL_ID_DOCUMENT";
    PrimaryIDs["VOTER_ID_DOCUMENT"] = "VOTER_ID_DOCUMENT";
})(PrimaryIDs || (PrimaryIDs = {}));
export var SecondaryIDs;
(function (SecondaryIDs) {
    SecondaryIDs["AFP_ID_DOCUMENT"] = "AFP_ID_DOCUMENT";
    SecondaryIDs["PNP_ID_DOCUMENT"] = "PNP_ID_DOCUMENT";
    SecondaryIDs["BRF_ID_DOCUMENT"] = "BRF_ID_DOCUMENT";
    SecondaryIDs["PWD_ID_DOCUMENT"] = "PWD_ID_DOCUMENT";
    SecondaryIDs["DSWD_CERTIFICATION_DOCUMENT"] = "DSWD_CERTIFICATION_DOCUMENT";
    SecondaryIDs["GSIS_ECARD_DOCUMENT"] = "GSIS_ECARD_DOCUMENT";
    SecondaryIDs["OFW_ID_DOCUMENT"] = "OFW_ID_DOCUMENT";
    SecondaryIDs["POLICE_CLEARANCE_DOCUMENT"] = "POLICE_CLEARANCE_DOCUMENT";
    SecondaryIDs["SEAMAN_BOOK_DOCUMENT"] = "SEAMAN_BOOK_DOCUMENT";
})(SecondaryIDs || (SecondaryIDs = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["SELFIE_WITH_PRIMARY_ID_DOCUMENT"] = "SELFIE_WITH_PRIMARY_ID_DOCUMENT";
    DocumentType["SELFIE_WITH_SECONDARY_ID_2_DOCUMENT"] = "SELFIE_WITH_SECONDARY_ID_2_DOCUMENT";
    DocumentType["SERVICE_AGREEMENT_DOCUMENT"] = "SERVICE_AGREEMENT_DOCUMENT";
    DocumentType["DRIVER_LICENCE_DOCUMENT"] = "DRIVER_LICENCE_DOCUMENT";
    DocumentType["PHILSYS_DOCUMENT"] = "PHILSYS_DOCUMENT";
    DocumentType["ACR_OR_IMMIGRANT_COR_DOCUMENT"] = "ACR_OR_IMMIGRANT_COR_DOCUMENT";
    DocumentType["UMID_DOCUMENT"] = "UMID_DOCUMENT";
    DocumentType["SSS_OR_GSIS_DOCUMENT"] = "SSS_OR_GSIS_DOCUMENT";
    DocumentType["PRC_LICENSE_DOCUMENT"] = "PRC_LICENSE_DOCUMENT";
    DocumentType["POSTAL_ID_DOCUMENT"] = "POSTAL_ID_DOCUMENT";
    DocumentType["VOTER_ID_DOCUMENT"] = "VOTER_ID_DOCUMENT";
    DocumentType["AFP_ID_DOCUMENT"] = "AFP_ID_DOCUMENT";
    DocumentType["PNP_ID_DOCUMENT"] = "PNP_ID_DOCUMENT";
    DocumentType["BRF_ID_DOCUMENT"] = "BRF_ID_DOCUMENT";
    DocumentType["PWD_ID_DOCUMENT"] = "PWD_ID_DOCUMENT";
    DocumentType["DSWD_CERTIFICATION_DOCUMENT"] = "DSWD_CERTIFICATION_DOCUMENT";
    DocumentType["GSIS_ECARD_DOCUMENT"] = "GSIS_ECARD_DOCUMENT";
    DocumentType["OFW_ID_DOCUMENT"] = "OFW_ID_DOCUMENT";
    DocumentType["POLICE_CLEARANCE_DOCUMENT"] = "POLICE_CLEARANCE_DOCUMENT";
    DocumentType["SEAMAN_BOOK_DOCUMENT"] = "SEAMAN_BOOK_DOCUMENT";
    DocumentType["DTI_REGISTRATION_DOCUMENT"] = "DTI_REGISTRATION_DOCUMENT";
    DocumentType["BIR_2303_DOCUMENT"] = "BIR_2303_DOCUMENT";
    DocumentType["SEC_CERTIFICATE_REGISTRATION_DOCUMENT"] = "SEC_CERTIFICATE_REGISTRATION_DOCUMENT";
    DocumentType["ARTICLES_OF_PARTNERSHIP_DOCUMENT"] = "ARTICLES_OF_PARTNERSHIP_DOCUMENT";
    DocumentType["NOTARIZED_PARTNER_CERTIFICATE_DOCUMENT"] = "NOTARIZED_PARTNER_CERTIFICATE_DOCUMENT";
    DocumentType["ARTICLES_OF_INCORPORATION_DOCUMENT"] = "ARTICLES_OF_INCORPORATION_DOCUMENT";
    DocumentType["NOTARIZED_SECRETARY_CERTIFICATE_DOCUMENT"] = "NOTARIZED_SECRETARY_CERTIFICATE_DOCUMENT";
    DocumentType["LATEST_GIS_DOCUMENT"] = "LATEST_GIS_DOCUMENT";
    DocumentType["PROOF_OF_COMPANY_REGISTRATION_DOCUMENT"] = "PROOF_OF_COMPANY_REGISTRATION_DOCUMENT";
    DocumentType["COUNTRY_ISSUED_BUSINESS_LICENSE_DOCUMENT"] = "COUNTRY_ISSUED_BUSINESS_LICENSE_DOCUMENT";
    DocumentType["BANK_BOOK_SCAN_DOCUMENT"] = "BANK_BOOK_SCAN_DOCUMENT";
    DocumentType["AUTHORIZED_PERSON_PASSPORT_DOCUMENT"] = "AUTHORIZED_PERSON_PASSPORT_DOCUMENT";
})(DocumentType || (DocumentType = {}));
export var IndustryType;
(function (IndustryType) {
    IndustryType["ACCOMMODATION"] = "ACCOMMODATION";
    IndustryType["ACCOUNTING_AUDITING_AND_BOOK_KEEPING"] = "ACCOUNTING_AUDITING_AND_BOOK_KEEPING";
    IndustryType["AIRLINE"] = "AIRLINE";
    IndustryType["AIRPORT"] = "AIRPORT";
    IndustryType["ALCOHOL"] = "ALCOHOL";
    IndustryType["ALTERATION_SERVICES"] = "ALTERATION_SERVICES";
    IndustryType["AMUSEMENT_PARK_CARNIVAL_CIRCUS"] = "AMUSEMENT_PARK_CARNIVAL_CIRCUS";
    IndustryType["ARCHITECTURE_ENGINEERING"] = "ARCHITECTURE_ENGINEERING";
    IndustryType["ART_AND_CRAFTS"] = "ART_AND_CRAFTS";
    IndustryType["ASSET_MANAGEMENT_COMPANY"] = "ASSET_MANAGEMENT_COMPANY";
    IndustryType["AUTOMOTIVE"] = "AUTOMOTIVE";
    IndustryType["BAKERY"] = "BAKERY";
    IndustryType["BANK"] = "BANK";
    IndustryType["BAR"] = "BAR";
    IndustryType["BEAUTY_SELLING_EXISTING_BRAND"] = "BEAUTY_SELLING_EXISTING_BRAND";
    IndustryType["BEAUTY_SELLING_OWN_BRAND"] = "BEAUTY_SELLING_OWN_BRAND";
    IndustryType["BOOK_AND_STATIONARY"] = "BOOK_AND_STATIONARY";
    IndustryType["BUS"] = "BUS";
    IndustryType["BUTCHER"] = "BUTCHER";
    IndustryType["CAFE_COFFEESHOP"] = "CAFE_COFFEESHOP";
    IndustryType["CAMERA_AND_PHOTOGRAPHY_SHOP"] = "CAMERA_AND_PHOTOGRAPHY_SHOP";
    IndustryType["CAMPING_SITE_AND_TRAILER_PARK"] = "CAMPING_SITE_AND_TRAILER_PARK";
    IndustryType["CAR_RENTAL"] = "CAR_RENTAL";
    IndustryType["CELLULAR_TELECOMUNICATION_SERVICE_PROVIDER"] = "CELLULAR_TELECOMUNICATION_SERVICE_PROVIDER";
    IndustryType["CEMETERY"] = "CEMETERY";
    IndustryType["CHARITY_AND_DONATION"] = "CHARITY_AND_DONATION";
    IndustryType["CHARITY_AND_SOCIAL_SERVICES"] = "CHARITY_AND_SOCIAL_SERVICES";
    IndustryType["CHEMICAL_MATERIAL"] = "CHEMICAL_MATERIAL";
    IndustryType["CHILDCARE_SERVICES"] = "CHILDCARE_SERVICES";
    IndustryType["CINEMA"] = "CINEMA";
    IndustryType["CLEANING_SERVICE_AND_SANITATION"] = "CLEANING_SERVICE_AND_SANITATION";
    IndustryType["CLOTHING_RENTAL"] = "CLOTHING_RENTAL";
    IndustryType["CONCERT_BAND_ORCHESTRA"] = "CONCERT_BAND_ORCHESTRA";
    IndustryType["COWORKING_SPACES"] = "COWORKING_SPACES";
    IndustryType["CRYPTOCURRENCY_EXCHANGE"] = "CRYPTOCURRENCY_EXCHANGE";
    IndustryType["DENTAL_CLINIC"] = "DENTAL_CLINIC";
    IndustryType["E_TICKETS"] = "E_TICKETS";
    IndustryType["E_WALLETS_E_MONEY"] = "E_WALLETS_E_MONEY";
    IndustryType["EDUCATION_INFORMAL_SKILL_COURSE_PHOTOGRAPHY_PAINTING"] = "EDUCATION_INFORMAL_SKILL_COURSE_PHOTOGRAPHY_PAINTING";
    IndustryType["EDUCATION_SCHOOL"] = "EDUCATION_SCHOOL";
    IndustryType["EDUCATION_UNIVERSITY"] = "EDUCATION_UNIVERSITY";
    IndustryType["EDUTECH"] = "EDUTECH";
    IndustryType["ELECTRONICS_AND_ACCESSORIES"] = "ELECTRONICS_AND_ACCESSORIES";
    IndustryType["ENTERTAINMENT"] = "ENTERTAINMENT";
    IndustryType["EVENT_SERVICES"] = "EVENT_SERVICES";
    IndustryType["FASHION_AND_ACCESSORIES"] = "FASHION_AND_ACCESSORIES";
    IndustryType["FAST_FOOD"] = "FAST_FOOD";
    IndustryType["FITNESS_AND_SPORT_CLUB"] = "FITNESS_AND_SPORT_CLUB";
    IndustryType["FLORIST"] = "FLORIST";
    IndustryType["FOOD_AND_BEVERAGE"] = "FOOD_AND_BEVERAGE";
    IndustryType["GAMING"] = "GAMING";
    IndustryType["GAS_STATION"] = "GAS_STATION";
    IndustryType["GIFT_SHOP"] = "GIFT_SHOP";
    IndustryType["HAJ_AND_UMRAH_PROVIDER"] = "HAJ_AND_UMRAH_PROVIDER";
    IndustryType["HEALTH_BEAUTY_CARE_SERVICES_NO_PHYSICAL_SITE"] = "HEALTH_BEAUTY_CARE_SERVICES_NO_PHYSICAL_SITE";
    IndustryType["HEALTH_BEAUTY_CARE_SERVICES_PHYSICAL"] = "HEALTH_BEAUTY_CARE_SERVICES_PHYSICAL";
    IndustryType["HEALTH_SUPPLEMENTS_EXISTING_BRAND"] = "HEALTH_SUPPLEMENTS_EXISTING_BRAND";
    IndustryType["HEALTH_SUPPLEMENTS_OWN_BRAND"] = "HEALTH_SUPPLEMENTS_OWN_BRAND";
    IndustryType["HEALTH_TECH"] = "HEALTH_TECH";
    IndustryType["HOME_PRODUCT_AND_FURNITURE"] = "HOME_PRODUCT_AND_FURNITURE";
    IndustryType["HOSPITAL"] = "HOSPITAL";
    IndustryType["INSURANCE"] = "INSURANCE";
    IndustryType["INTERNET_SERVICE_PROVIDER"] = "INTERNET_SERVICE_PROVIDER";
    IndustryType["INVESTMENT_SERVICES"] = "INVESTMENT_SERVICES";
    IndustryType["IT_SERVICES"] = "IT_SERVICES";
    IndustryType["KOPERASI_SIMPAN_PINJAM"] = "KOPERASI_SIMPAN_PINJAM";
    IndustryType["LABORATORY"] = "LABORATORY";
    IndustryType["LANDLINE_TELEPHONE_PROVIDER"] = "LANDLINE_TELEPHONE_PROVIDER";
    IndustryType["LAUNDRY_SERVICES"] = "LAUNDRY_SERVICES";
    IndustryType["LIVE_STREAMING"] = "LIVE_STREAMING";
    IndustryType["LOGISTICS"] = "LOGISTICS";
    IndustryType["MALL"] = "MALL";
    IndustryType["MANUFACTURING"] = "MANUFACTURING";
    IndustryType["MARKETING_SERVICES"] = "MARKETING_SERVICES";
    IndustryType["MARKETPLACE"] = "MARKETPLACE";
    IndustryType["MARTECH_ADTECH"] = "MARTECH_ADTECH";
    IndustryType["MEDICAL_SERVICE_AND_OTHER_PRACTICE"] = "MEDICAL_SERVICE_AND_OTHER_PRACTICE";
    IndustryType["MEMBERSHIPS"] = "MEMBERSHIPS";
    IndustryType["MOBILE_APPLICATION"] = "MOBILE_APPLICATION";
    IndustryType["MOM_AND_BABY_SHOP"] = "MOM_AND_BABY_SHOP";
    IndustryType["MULTI_FINANCE"] = "MULTI_FINANCE";
    IndustryType["MULTI_LEVEL_MARKETING"] = "MULTI_LEVEL_MARKETING";
    IndustryType["MUSIC"] = "MUSIC";
    IndustryType["ONLINE_COURSE"] = "ONLINE_COURSE";
    IndustryType["ONLINE_TRAVEL_AGENT"] = "ONLINE_TRAVEL_AGENT";
    IndustryType["OPTIC"] = "OPTIC";
    IndustryType["OPTICIAN_CLINIC"] = "OPTICIAN_CLINIC";
    IndustryType["OTHER_DIGITAL_PRODUCTS"] = "OTHER_DIGITAL_PRODUCTS";
    IndustryType["OTHER_ECOMMERCE"] = "OTHER_ECOMMERCE";
    IndustryType["OTHER_ENTERTAINMENT"] = "OTHER_ENTERTAINMENT";
    IndustryType["OTHER_FINANCIAL_SERVICES"] = "OTHER_FINANCIAL_SERVICES";
    IndustryType["OTHER_LENDINGS"] = "OTHER_LENDINGS";
    IndustryType["OTHER_NON_PROFIT"] = "OTHER_NON_PROFIT";
    IndustryType["OTHER_OFFLINE_RETAIL"] = "OTHER_OFFLINE_RETAIL";
    IndustryType["OTHER_PROPERTIES"] = "OTHER_PROPERTIES";
    IndustryType["OTHER_RESTAURANTS"] = "OTHER_RESTAURANTS";
    IndustryType["OTHER_SAAS"] = "OTHER_SAAS";
    IndustryType["OTHER_SERVICES"] = "OTHER_SERVICES";
    IndustryType["OTHER_TRAVEL_AND_HOSPITALITIES"] = "OTHER_TRAVEL_AND_HOSPITALITIES";
    IndustryType["OTHERS"] = "OTHERS";
    IndustryType["PAID_TV_SERVICES"] = "PAID_TV_SERVICES";
    IndustryType["PARKING"] = "PARKING";
    IndustryType["PAYMENT_GATEWAY"] = "PAYMENT_GATEWAY";
    IndustryType["PAYMENT_POINT_ONLINE_BANK"] = "PAYMENT_POINT_ONLINE_BANK";
    IndustryType["PEER_TO_PEER_LENDING"] = "PEER_TO_PEER_LENDING";
    IndustryType["PET_SHOP"] = "PET_SHOP";
    IndustryType["PHARMACY"] = "PHARMACY";
    IndustryType["PHOTO_STUDIO"] = "PHOTO_STUDIO";
    IndustryType["PRINTING"] = "PRINTING";
    IndustryType["PROPERTY_MANAGEMENT"] = "PROPERTY_MANAGEMENT";
    IndustryType["REFLEXOLOGY_AND_MASSAGE"] = "REFLEXOLOGY_AND_MASSAGE";
    IndustryType["RELIGIOUS_ORGANIZATION"] = "RELIGIOUS_ORGANIZATION";
    IndustryType["REMITTANCE"] = "REMITTANCE";
    IndustryType["RIDE_SHARING"] = "RIDE_SHARING";
    IndustryType["SALON_BARBER_SHOP_SPA"] = "SALON_BARBER_SHOP_SPA";
    IndustryType["SPORTING_GOODS"] = "SPORTING_GOODS";
    IndustryType["SUPER_MARKET_MINIMART"] = "SUPER_MARKET_MINIMART";
    IndustryType["TAXI"] = "TAXI";
    IndustryType["TICKETS_EVENTS"] = "TICKETS_EVENTS";
    IndustryType["TOUR"] = "TOUR";
    IndustryType["TOURIST_DESTINATION_AND_EXHIBITION"] = "TOURIST_DESTINATION_AND_EXHIBITION";
    IndustryType["TOYS_AND_GAMES_STORE"] = "TOYS_AND_GAMES_STORE";
    IndustryType["TRAIN"] = "TRAIN";
    IndustryType["TRAINING_AND_COURSES"] = "TRAINING_AND_COURSES";
    IndustryType["TRAVEL_AGENCY"] = "TRAVEL_AGENCY";
    IndustryType["UTILITIES"] = "UTILITIES";
    IndustryType["VET"] = "VET";
    IndustryType["WATCHES_AND_JEWELRY"] = "WATCHES_AND_JEWELRY";
    IndustryType["WATER_TRANSPORT"] = "WATER_TRANSPORT";
    IndustryType["WEDDING_AND_BRIDAL_SERVICES"] = "WEDDING_AND_BRIDAL_SERVICES";
    IndustryType["WHOLESALE"] = "WHOLESALE";
    IndustryType["ZAKAT_COLLECTION"] = "ZAKAT_COLLECTION";
})(IndustryType || (IndustryType = {}));
